import parse from "html-react-parser";

type HeroOneColumnProps = {
  tr_heading: string;
  tr_subheading: string;
  hero_image: string | null;
};

export const HeroOneColumn = ({
  tr_heading,
  tr_subheading,
  hero_image,
}: HeroOneColumnProps) => (
  <>
    <section className="upsell-header content-medium">
      <h1 className="upsell-title">{parse(tr_heading)}</h1>
      <div className="upsell-subtitle">{parse(tr_subheading)}</div>
    </section>

    {hero_image && (
      <section className="product-image-container content-medium">
        <img src={hero_image} alt="" className="product-image" />
      </section>
    )}
  </>
);
